document.addEventListener("DOMContentLoaded", () => {
  const compareListBox = document.querySelector(".compare-list-box");
  if (!compareListBox) {
    return;
  }

  const compareItems = Array.from(document.querySelectorAll(".compare-item"));

  function getHeightWithoutPadding(element) {
    const style = window.getComputedStyle(element);
    const height = element.offsetHeight;
    const paddingTop = parseFloat(style.paddingTop);
    const paddingBottom = parseFloat(style.paddingBottom);
    return height - paddingTop - paddingBottom;
  }

  function resetHeight(selector) {
    compareItems.forEach((item) => {
      item.querySelectorAll(selector).forEach((element) => {
        if (element.classList.contains("compare-item__blank")) {
          element.style.height = "auto";
        }
      });
    });
  }

  function setEqualHeight(selector) {
    const allElements = compareItems.map((item) =>
      Array.from(item.querySelectorAll(selector))
    );
    const maxHeights = [];

    for (let i = 0; i < allElements[0].length; i++) {
      let maxHeight = 0;
      allElements.forEach((elements) => {
        const element = elements[i];
        if (element) {
          const height = getHeightWithoutPadding(element);
          if (height > maxHeight) {
            maxHeight = height;
          }
        }
      });
      maxHeights.push(maxHeight);
    }

    allElements.forEach((elements) => {
      elements.forEach((element, index) => {
        if (element.classList.contains("compare-item__blank")) {
          element.style.height = `${maxHeights[index]}px`;
        }
      });
    });
  }

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  const debouncedSetEqualHeight = debounce(() => {
    resetHeight(".compare-icon-list-item");
    resetHeight(".compare-text-list-item");
    setEqualHeight(".compare-icon-list-item");
    setEqualHeight(".compare-text-list-item");
    alignCubes("icon");
    alignCubes("text");
  }, 2000);

  window.addEventListener("resize", () => {
    debouncedSetEqualHeight();
  });

  setEqualHeight(".compare-icon-list-item");
  setEqualHeight(".compare-text-list-item");
  // section-product-compare-list.js
  const getLongestValueInSubArrays = (arr) => {
    let maxLength = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].length > maxLength) {
        maxLength = arr[i].length;
      }
    }
    return maxLength;
  };
  const container = document.querySelector(".compare-list-box");

  const alignCubes = (type) => {
    const columnsIcon = container.querySelectorAll(
      ".compare-" + type + "-list"
    );
    const heightGroupArrayIcon = [];
    let longestValueIcon = 0;
    columnsIcon.forEach((col) => {
      heightGroupArrayIcon.push(
        Array.from(col.querySelectorAll(".compare-" + type + "-list-item")).map(
          (o) => o.clientHeight
        )
      );
    });
    longestValueIcon = getLongestValueInSubArrays(heightGroupArrayIcon);
    let heightArray = [];
    for (let index = 0; index < longestValueIcon; index++) {
      let arr = [];
      heightGroupArrayIcon.forEach((group, _groupIndex) => {
        arr.push(group[index]);
      });
      heightArray.push(arr);
    }
    heightArray = heightArray.map((o) => Math.max(...o));
    columnsIcon.forEach((col) => {
      const items = col.querySelectorAll(".compare-" + type + "-list-item");
      items.forEach((item, index) => {
        item.style.minHeight = heightArray[index] - 32 + "px";
      });
    });
  };
  alignCubes("icon");
  alignCubes("text");
});
